<template>
  <div class="channel-card">
    <div class="title-data">
      <span>{{ $t('lang.k_315001') }}</span>
    </div>
    <div class="channel-main">
      <div class="search-data">
        <vh-button size="medium" class="length104" type="primary" @click="createChannel()" round>
          {{ $t('lang.k_315002') }}
        </vh-button>
        <vh-button
          size="medium"
          class="head-btn length104 transparent-btn"
          round
          plain
          @click="allDelete(null)"
          :disabled="!channel_ids.length"
        >
          {{ $t('lang.k_315003') }}
        </vh-button>
        <vh-input
          round
          class="search-tag"
          :placeholder="$t('lang.k_315004')"
          v-model="keyword"
          clearable
          @clear="initQueryUserList"
          @keyup.enter.native="initQueryUserList"
        >
          <i class="vh-icon-search vh-input__icon" slot="prefix" @click="initQueryUserList"></i>
        </vh-input>
      </div>
      <div class="channel-card-list">
        <div class="list-table-panel" v-if="tableList.length != 0">
          <!-- 表格与分页 -->
          <vh-table
            ref="tableList"
            :data="tableList || []"
            @selection-change="handleTableCheckbox"
            :header-cell-style="{
              color: '#666',
              height: '56px'
            }"
          >
            <vh-table-column type="selection" :selectable="selectableFuc" width="60" align="left" />
            <vh-table-column
              align="left"
              v-for="(item, index) in baseTableColumn"
              :key="index"
              :width="item.width"
              :label="item.label"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span :class="item.key">
                  <template v-if="item.key == 'channel_name'">
                    <span>{{ $t(scope.row[item.key]) }}</span>
                    <vh-tag class="tip" size="mini" v-show="scope.row.channel_type == 0">
                      {{ $t('lang.k_315005') }}
                    </vh-tag>
                  </template>
                  <template v-else-if="item.key == 'updated_at'">
                    <div v-if="scope.row.channel_type != 0 && scope.row.channel_type != 1">
                      <p class="eps">{{ scope.row.last_operator_nickname }}</p>
                      <p>{{ scope.row[item.key] }}</p>
                    </div>
                  </template>
                  <template v-else>{{ scope.row[item.key] }}</template>
                </span>
              </template>
            </vh-table-column>
            <vh-table-column :label="$t('lang.k_315006')" align="left" width="200px">
              <template slot-scope="scope">
                <span
                  class="tool"
                  v-show="scope.row.channel_type != 0 && scope.row.channel_type != 1"
                  @click="editChannel(scope.row)"
                >
                  {{ $t('lang.k_315007') }}
                </span>
                <span
                  class="tool"
                  v-show="scope.row.channel_type != 0 && scope.row.channel_type != 1"
                  @click="deleteChannel(scope.row)"
                >
                  {{ $t('lang.k_315008') }}
                </span>
              </template>
            </vh-table-column>
          </vh-table>
          <SPagination
            :total="total || 0"
            :page-size="limit"
            :currentPage="pageNumber"
            @current-change="currentChangeHandler"
            @size-change="handleSizeChange"
          ></SPagination>
        </div>
        <!-- 无消息内容 -->
        <null-page class="search-no-data" v-else></null-page>
      </div>
    </div>

    <VhallDialog
      :title="channel.id ? $t('lang.k_315009') : $t('lang.k_315002')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      custom-class="channel-dialog"
      width="468px"
    >
      <vh-form label-width="80px" :model="channel" ref="channelForm" :rules="rules">
        <vh-form-item :label="$t('lang.k_315010')" prop="name">
          <vh-input
            v-model="channel.name"
            :maxlength="100"
            show-word-limit
            :placeholder="$t('lang.k_315011')"
            autocomplete="off"
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_315012')" prop="code">
          <vh-input
            v-model="channel.code"
            :maxlength="100"
            show-word-limit
            :placeholder="$t('lang.k_315013')"
            autocomplete="off"
            :disabled="!!channel.id"
          ></vh-input>
        </vh-form-item>
      </vh-form>
      <div class="indent">{{ $t('lang.k_315014') }}</div>
      <span slot="footer" class="dialog-footer create-footer">
        <vh-button type="info" size="medium" @click="dialogVisible = false" plain round>
          {{ $t('lang.k_315015') }}
        </vh-button>
        <vh-button type="primary" size="medium" v-preventReClick @click="saveChannelHandle" round>
          {{ $t('lang.k_315016') }}
        </vh-button>
      </span>
    </VhallDialog>
  </div>
</template>
<script>
  import NullPage from '../PlatformModule/Error/nullPage.vue';
  import regRule from '@/utils/reg-rule';
  export default {
    data() {
      const validCode = (rule, value, callback) => {
        if (value && !regRule['codePwd'].test(value)) {
          return callback(new Error(this.$t('lang.k_315017')));
        } else {
          callback();
        }
      };
      return {
        channel_ids: [],
        keyword: '',
        pos: 0,
        pageNumber: 1,
        limit: 20,
        total: 0,
        tableList: [],
        baseTableColumn: [
          {
            label: this.$t('lang.k_315018'),
            key: 'channel_name',
            width: 'auto'
          },
          {
            label: this.$t('lang.k_315019'),
            key: 'channel_code',
            width: 'auto'
          },
          {
            label: this.$t('lang.k_315020'),
            key: 'updated_at',
            width: 'auto'
          }
        ],

        dialogVisible: false,
        channel: {
          id: '',
          name: ''
        },
        rules: {
          name: [{ required: true, message: this.$t('lang.k_315011'), trigger: 'blur' }],
          code: [{ validator: validCode, trigger: 'blur' }]
        }
      };
    },
    components: {
      NullPage
    },
    created() {},
    mounted() {
      this.initQueryUserList();
    },
    methods: {
      selectableFuc(row) {
        return row.channel_type != 0 && row.channel_type != 1;
      },
      // 页码改变按钮事件
      currentChangeHandler(current) {
        this.pageNumber = current;
        this.pos = parseInt((current - 1) * this.limit);
        this.getChannelTableList();
      },
      // 每页显示个数选择器的选项设置 改变按钮事件
      handleSizeChange(current) {
        this.pageNumber = 1;
        this.limit = current;
        this.pos = 0;
        this.getChannelTableList();
      },
      // 复选框操作
      handleTableCheckbox(val) {
        console.log(val);
        this.channel_ids = val.map(item => item.id);
      },
      initQueryUserList() {
        this.pos = 0;
        this.pageNumber = 1;
        this.limit = 20;
        // 表格切换到第一页
        this.$nextTick(() => {
          if (this.$refs.tableList && this.$refs.tableList.pageInfo) {
            this.$refs.tableList.pageInfo.pageNum = 1;
            this.$refs.tableList.pageInfo.pos = 0;
          }
          this.getChannelTableList();
        });
      },
      getChannelTableList(row) {
        if (row) {
          this.pos = row.pos;
          this.pageNumber = row.pageNum;
        }
        this.loading = true;
        let params = {
          keyword: this.keyword,
          pos: this.pos,
          limit: this.limit
        };
        this.$fetch('getChannelList', this.$params(params), {
          'Content-Type': 'application/json'
        }).then(res => {
          // 有数据但是当前页没有
          if (
            res &&
            res.code === 200 &&
            res.data &&
            res.data.list.length == 0 &&
            res.data.total != 0
          ) {
            this.getChannelTableList({ pos: 0, pageNum: 1 });
            return;
          }

          this.total = res.data.total;
          this.tableList = res.data.list;
          console.log(this.tableList, '????????this.tableList');
        });
      },
      deleteChannel(rows) {
        this.deleteConfirm(rows.id);
      },
      deleteConfirm(id) {
        this.$vhConfirm(this.$t('lang.k_315021'), this.$t('lang.k_315022'), {
          confirmButtonText: this.$t('lang.k_315016'),
          cancelButtonText: this.$t('lang.k_315015'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,

          cancelButtonClass: 'zdy-confirm-cancel'
        }).then(() => {
          this.$fetch(
            'deleteChannel',
            {
              channel_ids: id
            },
            {
              'Content-Type': 'application/json'
            }
          )
            .then(res => {
              if (res && res.code === 200) {
                this.$vhMessage({
                  message: this.$t('lang.k_315023'),
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                // 刷新页面
                this.$refs.tableList && this.$refs.tableList.clearSelection();
                this.getChannelTableList();
                this.channel_ids = [];
              }
            })
            .catch(res => {
              this.$vhMessage({
                message: res.msg || this.$t('lang.k_315024'),
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        });
      },
      allDelete(id) {
        id = this.channel_ids.join(',');
        this.deleteConfirm(id);
      },
      createChannel() {
        if (this.total > 200) {
          this.$vhMessage({
            message: this.$t('lang.k_315025'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        } else {
          this.channel.id = '';
          this.$set(this.channel, 'name', '');
          this.$set(this.channel, 'code', '');
          // this.$refs['channelForm'].resetFields();
          this.dialogVisible = true;
        }
      },
      editChannel(row) {
        this.channel.id = row.id;
        this.$set(this.channel, 'name', row.channel_name);
        this.$set(this.channel, 'code', row.channel_code);
        // this.$refs['channelForm'].resetFields();
        this.dialogVisible = true;
      },
      saveChannelHandle() {
        this.$refs.channelForm.validate(valid => {
          if (valid) {
            this.$fetch(
              'saveChannel',
              {
                channel_id: this.channel.id,
                channel_name: this.channel.name,
                channel_code: this.channel.code
              },
              {
                'Content-Type': 'application/json'
              }
            )
              .then(res => {
                if (res && res.code === 200) {
                  this.dialogVisible = false;
                  this.getChannelTableList();
                } else {
                  this.$vhMessage({
                    message: res.msg || this.$t('lang.k_315026'),
                    showClose: true,
                    // duration: 0,
                    type: 'error',
                    customClass: 'zdy-info-box'
                  });
                }
              })
              .catch(res => {
                this.$vhMessage({
                  message: res.msg || `${this.$t('lang.k_315026')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          }
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .channel-card-list {
    background-color: #fff;
    padding: 24px;
    min-height: 676px;
  }
  .channel-card {
    .title-data {
      margin: 0 0 20px 0;
      text-align: left;
      line-height: 30px;
      span {
        font-size: 22px;
        font-weight: 600;
        color: #1a1a1a;
      }
      .subTitle {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        margin-left: 12px;
      }
      .tool {
        color: #3562fa;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;
      }
      .button-tip {
        vertical-align: top;
      }
    }
    .channel-main {
      .vh-card__body {
        padding: 32px 24px;
      }
      .search-data {
        margin-bottom: 30px;
      }

      .search-tag {
        float: right;
        width: 220px;
      }

      .list-table-panel {
        min-height: auto;
        .vh-table {
          .vh-table__body .cell {
            .webinar_num,
            .tool {
              color: #3562fa;
              cursor: pointer;
            }
          }
          .vh-table__row .tool {
            margin-right: 16px;
          }
          td:last-child,
          th:last-child {
            padding-right: 24px;
            text-align: right;
          }
          .tip {
            margin-left: 6px;
          }

          .eps {
            max-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .channel-dialog {
      .indent {
        padding-left: 80px;
        line-height: 1.5;
        color: #8c8c8c;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
      }
      .vh-form-item {
        margin-bottom: 16px;
      }
    }
  }
  .no-live {
    .btn-list .vh-button {
      margin-right: 0;
    }
  }
</style>
<style lang="less">
  .channel-card {
    .vh-input--limit .vh-input__inner {
      padding-right: 58px;
    }
  }
  .vh-tooltip__popper {
    max-width: 450px;
  }
</style>
